export const appConfig = {
  version: '2026.3.0',
}
